import { render, staticRenderFns } from "./DeleteBtn.vue?vue&type=template&id=5e7226bd&scoped=true&"
import script from "./DeleteBtn.vue?vue&type=script&lang=js&"
export * from "./DeleteBtn.vue?vue&type=script&lang=js&"
import style0 from "./DeleteBtn.vue?vue&type=style&index=0&id=5e7226bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7226bd",
  null
  
)

export default component.exports